import LabeledImageInput from "components/labeledInput/LabeledImageInput";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledImageInput);
